import React, {useState, useContext, useEffect} from 'react';
import { IonText, IonGrid, IonRow, IonCol, IonButton, IonModal, IonHeader, IonFooter } from '@ionic/react';
import ReactDOM from 'react-dom';


import { ShowRoomPicsModal } from './Modal_ShowRoomPics';
import { EnterCheckInInfoModal } from './Modal_EnterCheckInInfo';
import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';
//import { classicNameResolver } from 'typescript';

import '../../../../css/qavaApp.css';


export function ViewAvailableRoomsModal (props) {


    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [roomPicsModal, setRoomPicsModal] = useState(false);
    let [checkInModal, setCheckInModal] = useState(false);

    let [checkInModal_tracker, setCheckInModal_tracker] = useState(null);

    let [viewInventoryAvailableRooms, setViewInventoryAvailableRooms] = useState([]);

    let [roomID, setRoomID] = useState(null);
    let [roomSalePrice, setRoomSalePrice] = useState(null);
    let [roomPic1, setroomPic1] = useState(null);
    let [roomPic2, setroomPic2] = useState(null);
    let [roomPic3, setroomPic3] = useState(null);
    let [roomPic4, setroomPic4] = useState(null);



    useEffect(() => {


        if(props.openModal == true)
        {

             /*
            let formData = new FormData();
            formData.append('Tracker', 74101);
            formData.append('user', acctID);
            formData.append('xStartDateRange', props.startDate.toISOString().substr(0, 10));
            formData.append('xEndDateRange', props.endDate.toISOString().substr(0, 10));
                

            const requestOptions = {
                enctype: 'multipart/form-data',
                method:'POST',
                credentials: 'include',
                files: formData,
                body: formData,
                contentType: false,
                processData: false,
            }
            */

            const requestOptions = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                body: JSON.stringify({
                    Tracker: '74101',
                    user: acctID,
                    xStartDateRange: authenticatedMerchent_context.startDate,
                    xEndDateRange: authenticatedMerchent_context.endDate,
                    sessionID: sessionID,
    
                }),
            }

            
            fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(res => {

                let rows = res.toString().split('~~~');

                for (let rownum = 0; rownum < rows.length - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');

                    //alert('Inside ViewAvailableRooms FETCH');
                    //alert(cols[9]);
                    //alert(cols[10]);
                    //alert(cols[11]);
                    //alert(cols[12]);



                    setViewInventoryAvailableRooms((prevAvailableRooms) => {
                        return prevAvailableRooms.concat({
                            roomID: cols[0],
                            roomType: cols[1],
                            roomDescription: cols[2],
                            roomPartNum: cols[3],
                            roomPhoneNumber: cols[4],
                            address: cols[5],
                            city: cols[6],
                            country: cols[7],
                            roomSalePrice: parseFloat(cols[8]).toFixed(2),
                            roomPic1: cols[9],
                            roomPic2: cols[10],
                            roomPic3: cols[11],
                            roomPic4: cols[12],
                            attachement: cols[13],
                        })
                    });
                } 
            })
        }
    }, [props.openModal]);

    function closeModalHandler(event) {

        //alert('Inside closeModalHandler');
        setViewInventoryAvailableRooms([]);
        props.closeModal(event);
    }

    function closeModalHandler_checkIn()
    {
        setRoomID(null);
        setRoomSalePrice(null);
        setCheckInModal_tracker(null);
        setCheckInModal(false);
    }

    function roomPicsModalHandler(event) {
        setroomPic1(event[1]);
        setroomPic2(event[2]);
        setroomPic3(event[3]);
        setroomPic4(event[4]);
        setRoomID(event[5]);
        setRoomSalePrice(event[6]);
        setRoomPicsModal(event[0]);

    }
 
    function checkInModalHandler(event) {

        //alert('Inside Entern Check-In Handler');
        //alert(event[0]);
        //alert(event[1]);
        //alert(event[2]);

        setRoomID(event[1]);
        setRoomSalePrice(event[2]);
        setCheckInModal(event[0]);

    }

    function checkInModalHandler_multiple(event) {

        //alert('Inside Entern Check-In Handler');
        //alert(event[0]);
        //alert(event[1]);
        //alert(event[2]);

        setRoomID('multiple');
        setRoomSalePrice('multiple');
        setCheckInModal_tracker(event[1]);
        setCheckInModal(event[0]);

    }
    //alert('Inside ViewAvailableRooms');
    //alert(props.openModal);
    //alert(openModal);

    return (

        <React.Fragment>            
            {props.openModal == true ?
            (
                <IonModal isOpen={ props.openModal }>

                    <IonHeader className='appModalHeader'>
                        <h3> Rooms Available </h3>
                    </IonHeader>

                    <IonGrid className='appGridContent'>

                        <IonRow >
                                <IonCol > <h3> Room ID </h3></IonCol>
                                <IonCol > <h3> Room Type </h3> </IonCol>
                                {/*<IonCol > <h3> Part Number </h3> </IonCol>*/}
                                {/*<IonCol > <h3> Phone Number </h3> </IonCol>*/}
                                <IonCol > <h3> Sale Price </h3> </IonCol>                                        
                                <IonCol > <h3> Action </h3> </IonCol>
                        </IonRow>
                        {viewInventoryAvailableRooms.map((detailData) =>   {
                            return (
                                <IonRow key={detailData.roomID}>
                                    <IonCol >{detailData.roomID}</IonCol>
                                    <IonCol >{detailData.roomType}</IonCol>
                                    {/*<IonCol >{detailData.roomPartNum}</IonCol>*/}
                                    {/*<IonCol >{detailData.roomPhoneNumber}</IonCol>*/}
                                    <IonCol >{detailData.roomSalePrice}</IonCol>
                                    <IonCol >
                                        <IonButton  onClick={() => roomPicsModalHandler([true, detailData.roomPic1, detailData.roomPic2, detailData.roomPic3, detailData.roomPic4, detailData.roomID, detailData.roomSalePrice])}> Images </IonButton>
                                        <IonButton  onClick={() => checkInModalHandler([true, detailData.roomID, detailData.roomSalePrice])}> Check-In </IonButton>
                                    </IonCol>
                                </IonRow>
                            )
                        }
                        )}
                        <IonRow>
                            <IonCol>
                                <IonButton onClick={() => checkInModalHandler_multiple([true, 74101])}> Check-In Multiple </IonButton>
                            </IonCol>
                        </IonRow>
                    </IonGrid>

                    <ShowRoomPicsModal openModal={ roomPicsModal } closeModal={() => setRoomPicsModal(false)} data={{
                        roomPic1: roomPic1, 
                        roomPic2: roomPic2, 
                        roomPic3: roomPic3, 
                        roomPic4: roomPic4, 
                        roomID: roomID, 
                        roomSalePrice: roomSalePrice
                        }}>
                    </ShowRoomPicsModal>

                    {checkInModal == true && <EnterCheckInInfoModal openModal={ checkInModal } closeModal={() => closeModalHandler_checkIn()} tracker={checkInModal_tracker} data={{
                        roomID: roomID, 
                        roomSalePrice: roomSalePrice
                        }}>
                    </EnterCheckInInfoModal>}

                    <IonFooter className='modal_footer_button_center'>
                        <IonButton onClick={closeModalHandler}> Close </IonButton>
                    </IonFooter>
                </IonModal>            
            ) : null }
        </React.Fragment>

    )
}